export const adjustAnchorScroll = (): void => {
  const headerOffset = 110

  const scrollToAnchor = (): void => {
    if (window.location.hash) {
      const id = window.location.hash.substring(1)
      const target = document.getElementById(id)
      if (target) {
        const elementPosition = target.getBoundingClientRect().top + window.scrollY
        const offsetPosition = elementPosition - headerOffset
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }

  window.addEventListener('load', () => {
    setTimeout(scrollToAnchor, 500)
  })

  window.addEventListener('hashchange', () => {
    setTimeout(scrollToAnchor, 500)
  })
}
